


























































import { Component, Vue, Watch } from "vue-property-decorator";
import router from '../router';
import axios from 'axios';
import config from '../config';

@Component({
  components: {},
})
export default class Navbar extends Vue {
  clientName = "";

  get loggedIn() {
    return this.$store.state.authentication.status.loggedIn;
  }

  @Watch('loggedIn')
  onLoggedInChanged(loggedIn: boolean) {
    if (loggedIn) {
      this.fetchClientName();
    } else {
      this.clientName = "";
    }
  }

  async mounted() {
    if (!this.loggedIn) return;
    await this.fetchClientName();
  }

  async fetchClientName() {
    try {
      const response: any = await axios({
        method: 'get',
        url: config.apiEndpoint + "organizations",
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.$store.state.authentication.token,
          'x-access-token': this.$store.state.authentication.token,
        },
      });
      if (response.data.success && response.data.data.organization) {
        const org = response.data.data.organization;
        this.clientName = org.organizationName || org.clientName;
      }
    } catch (e) {
      // silently fail — navbar still works without the name
    }
  }

  logout() {
    const { dispatch } = this.$store;

    dispatch('authentication/logout');

    router.push('/login');
  }
}
